import { render } from "./PersonaEditor.vue?vue&type=template&id=4b03b9e3&scoped=true"
import script from "./PersonaEditor.vue?vue&type=script&lang=js"
export * from "./PersonaEditor.vue?vue&type=script&lang=js"

import "./PersonaEditor.vue?vue&type=style&index=0&id=4b03b9e3&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b03b9e3"]])

export default __exports__